import { PropsWithChildren } from "react";

import { useDocumentTitle } from "../use-document-title";
import styles from "./stub-page.module.css";

export type StubPageProps = PropsWithChildren<{
  title: string;
  description: string;
}>;

/** Shared shape for this bootstrap's placeholder page routes. */
export function StubPage({ title, description, children }: StubPageProps) {
  useDocumentTitle(title);

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.description}>{description}</p>
      {children}
    </div>
  );
}
